import React from 'react';


class Mail extends React.Component {
    constructor() {
        super();
        this.state = {
            email: ""
        }
    }
    updateEmail(value) {
        this.setState({
            email: value
        });
    }
    addEmail() {
        if (!this.state.email) return;
        const signupString = "Email: " + this.state.email + " ::: URL:" + window.location.href + " ::: Guid: " + window.userGuid;
        const ga = window.ga;
        const mixpanel = window.mixpanel;
        const keen = window.keenClient;
        const $ = window.$;

        window.email = this.state.email;
        ga('send', 'event', 'Signup Form', 'Signed Up', signupString);
        mixpanel.track("Signed Up", {
            "email": this.state.email,
            "url": window.location.href
        });
        keen.recordEvent('signup', {
            user: this.state.email,
            url: window.location.href
        });

        $('#thank_you_modal').modal('show');
        this.setState({
            email: ""
        });

    }
    render() {
        return (
            <div>
                <h4>Sign up for updates</h4>
                <input
                    type="text"
                    className="form-control"
                    value={this.state.email}
                    placeholder="Email"
                    onChange={(e) => this.updateEmail(e.target.value)}
                    style={{ marginTop: 5 }} />

                <button
                    onClick={() => this.addEmail()}
                    className="btn btn-default"
                    style={{ borderRadius: 0, borderWidth: 2, marginTop: 10, color: "#373737" }}>
                    Sign Up
                </button>

                <div className="modal fade" id="thank_you_modal" role="dialog" aria-labelledby="myModalLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h4 className="modal-title" id="myModalLabel">Thank you</h4>
                            </div>
                            <div className="modal-body">
                                Thank you for signing up!
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Mail;


// WEBPACK FOOTER //
// ./src/components/Mail/Mail.js